import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import dataProvider from 'shared/rest';

export default function AppcuesLoader(props) {
  const { currentUser } = props;
  useEffect(() => {
    (async () => {
      if (window.Appcues && currentUser) {
        const { id, role } = currentUser;
        //1. fetch Appcues Info
        // - add an api in function rest
        //2. identify appcuesInfo.hasAttendedEvents
        let params = {
          userId: id,
        };
        let user_roles = role;
        if (role && role !== '') {
          user_roles = role.split(',').join('|');
        }
        window.Appcues.identify(id, {
          user_roles,
          name: currentUser.name,
          email: currentUser.email,
        });
        dataProvider.invoke('appCues', 'getAppcuesInfo', params).then(res => {
          const { data } = res;
          window.Appcues.identify(id, {
            has_attended_events: data.hasAttendedEvents,
          });
        });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser]);
  return <div></div>;
}

AppcuesLoader.propTypes = {
  currentUser: PropTypes.object,
};
